import React from 'react';
import { X, Check, ArrowLeft, FileText } from 'lucide-react';

interface PDFViewModalProps {
  isOpen: boolean;
  pdfUrl: string;
  fileName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isUploading: boolean;
  title?: string;
}

const PDFViewModal: React.FC<PDFViewModalProps> = ({
  isOpen,
  pdfUrl,
  fileName,
  onConfirm,
  onCancel,
  isUploading,
  title = 'Preview PDF'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-apple max-w-4xl w-full mx-4 max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <FileText className="w-6 h-6 text-red-500 mr-3" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
              <p className="text-sm text-gray-600">{fileName}</p>
            </div>
          </div>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 p-2"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="flex-1 p-6 overflow-hidden">
          <div className="w-full h-full border border-gray-200 rounded-apple overflow-hidden">
            <iframe
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
              className="w-full h-full"
              title={`PDF Preview - ${fileName}`}
              style={{ minHeight: '500px' }}
            />
          </div>
        </div>
        
        <div className="flex items-center justify-end p-6 border-t border-gray-200 bg-gray-50">
          <div className="flex space-x-3">
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-secondary"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isUploading}
              className="btn btn-primary"
            >
              {isUploading ? (
                'Uploading...'
              ) : (
                <>
                  <Check className="w-4 h-4 mr-2" />
                  Confirm Upload
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFViewModal;
